import { mediaSM } from "./common";

const youtubeApiInit = (ready) => {
  var tag = document.createElement('script');

  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  window.youTubePlayers = [];

  var playerDivs;
  
  if ($(window).width() >= mediaSM) {
    playerDivs = $('.video-iframe');
  } else {
    playerDivs = $('.video-iframe').not('.xs-disabled-video');
  }

  var playerDivsArr = [...playerDivs];

  //filtrowanie powtarzających się elementów
  let playerDivsArrFiltered = playerDivsArr.filter((player, index, self) =>
    index === self.findIndex((t) => {
      return $(t).attr('id') === $(player).attr('id')
    })
  )

  playerDivsArr = playerDivsArrFiltered;

  var readyElements = [];

  window.onYouTubeIframeAPIReady = function () {
    
    playerDivsArr.forEach(function (e, i) {
      const $this = $(e),
        loop = $this.data('loop') || 0,
        videoId = $this.data('video-id') || '';
        
      var player = new YT.Player(e.id, {
        playerVars: {
          controls: 0,        // Show pause/play buttons in player
          showinfo: 0,        // Hide the video title
          modestbranding: 1,  // Hide the Youtube Logo
          loop: loop,            // Run the video in a loop
          playlist: videoId,
          videoId: videoId,
          rel: 0
        },
        events: {
          'onReady': onPlayerReady,
          // 'onStateChange': onPlayerStateChange
        }
      });

      youTubePlayers.push(player);

      function onPlayerReady() {
        readyElements.push(i);

        if (readyElements.length === playerDivsArr.length) { 
          ready();
        } else if (playerDivsArr.length === 0) {
          ready();
        }
      }

      function onPlayerStateChange(e) {

      }
    });
  };    
};

const iframeReady = function(callback, videoID) {
  function ready() {
    setTimeout(() => {
      youTubePlayers.forEach(e => {
        if(e.a.id === videoID) {
          if (typeof e.mute === "function") {               
            callback(e);
          } else {      
            ready();
          }              
        }
      });
    }, 100);          
  }

  function checkReady() {
    setTimeout(() => {
      if (youTubePlayers.length > 0) {
        ready();
      } else {
        checkReady();
      }
    }, 100);          
  }
  checkReady();
}

export default youtubeApiInit;
export {iframeReady};


// WEBPACK FOOTER //
// ./src/js/components/youtubeApiInit.js